<template>
<vue-markdown>
#### 1. 如何创建打印任务
简而言之，选中订单，点击`打印`按钮即可创建打印任务。但是需要注意几个问题：

1. 可以跨页选取订单，比如在第一页选中了10个订单， 可以点击`下一页`按钮（或者键盘快件键右键）跳到下一页选取更多订单一并拼板
2. 不同的产品也可以合并拼板。对于多个产品，如果只是产品码不同而尺寸纸张装帧等都相同，那么可以一起选中拼板
3. 下图显示了选中的订单个数以及不同产品的大小， 这是为了避免合板后文件过大， 打印机不能处理而做的提醒
![](/assets/docs/manage-task-select-orders.png)
4. 如果订单已经被拼板，订单列表会显示对应的打印任务，重复选择这些订单可能会造成重复打印
![](/assets/docs/manage-task-order-task.png)
5. 为了避免重复选择订单导致重复打印，可以搜索**下载完毕**的订单。订单在创建打印任务之后，订单状态会变为**拼板中**。因此**下载完毕**的订单是安全的

#### 2. 拼板的四种方式以及区别
拼板任务创建之后会立即收取该任务订单的打印费用，但是重复拼板不会重复收取。我们提供了四种拼板方式：

* `拷贝文件`： 将订单的pdf拷贝到指定目录不做任何修
* `合并选中文件`： 将所有订单的pdf首尾相连。如果一个订单需要打印多分，我们会在这个合板后的pdf里面多复制几份，因此不会有文件缺失的情况
* 相同页数的产品 `合拼`： 最终生成A3或者B2的pdf
* 不同页数的产品 `叠拼`： 最终生成A3或者B2的pdf

理论上任何产品都可以自由选择上述任何一种拼板方式。但是对于`合拼/叠拼`。请事先联系管理员设置好拼板参数，在核对首次拼板出来的pdf没有问题的前提下，可以使用此拼板方法。
`合拼`和`叠拼`目前支持如下参数的调节：
1. 原pdf是否需要缩放以及缩放的倍数
2. 缩放后，pdf四边分别要裁切掉多少（出血）
3. 是否绘制角线，角线的长度
4. 是否添加分隔页
5. 角线于角线之间的间隔
6. 生成A3还是B2大小的pdf（其他尺寸也支持）


#### 3. 重新执行任务
因为某些原因需要重新获取任务文件，**不需要**重新创建打印任务，直接点击下图中的`再次执行`按钮即可
![](/assets/docs/task-operation.png)

#### 4. 撤销任务/删除任务
`撤销任务`：此按钮位于任务界面，可以让该任务下的所有订单状态变为`下载完毕`。如果创建了任务，因为某些原因， 比如发现漏掉了几个订单，选择了错误的订单等**需要重新创建任务时**可以点击此按钮。
`删除任务`：此按钮位于任务列表界面。注意以下几点：
1. 禁止删除已经被打印的任务，同理，删除任务前请确认该打印文件没有被拿去打印。
2. 删除任务不会改变订单的状态。删除后订单的状态依然是`拼板成功`（或者`拼板失败`）， 如果需要重置这个任务的状态，请先点击`撤销任务`按钮。
3. 删除任务会把该任务拼板好的文件也一并删除。
4. 删除任务不会影响订单的扣款。


#### 5. 如果打印任务的某一个文件有问题该怎么办？
1. 到该订单界面点击`替换订单`按钮， 替换该订单文件。
2. 到任务界面点击`再次执行`按钮。等待生成新的合板文件。

#### 6. 如何修改任务名
到任务界面， 点击`修改任务名`按钮即可

</vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'help-search-orders',
  components: {
    'vue-markdown': VueMarkdown
  }
}
</script>